import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';


export const StyledTheaterContent = styled('div')`
	width: 100%;
	height: 100%;
	position: relative;
`;

export const SvgIcon = styled('svg')`
	width: 100%;
	height: 100%;
	fill: ${StyleColor.White};
`;

export const Image = styled('img')`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
	max-width: 100%;
	max-height: 100%;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Content/styles.ts